<template>
  <div class="slot-inspector-results">
    <SlotInspectorEhrWarning v-if="report.notInEhrWarning" :warning="report.notInEhrWarning" />
    <SlotInspectorSummary ref="summary" :range-label="report.rangeLabel" :totals="report.totals" />
    <SlotInspectorDepartment
      v-for="section in report.sections"
      :key="section.key"
      :section="section"
      :reasons="report.reasons"
      :show-provider-ids="report.showProviderIds"
    />
  </div>
</template>

<script setup>
import { useTemplateRef } from "vue";
import SlotInspectorDepartment from "./SlotInspectorDepartment.ce.vue";
import SlotInspectorEhrWarning from "./SlotInspectorEhrWarning.ce.vue";
import SlotInspectorSummary from "./SlotInspectorSummary.ce.vue";

defineProps({
  /**
   * A preview payload with at least one section.
   */
  report: {
    type: Object,
    required: true,
  },
});

const summary = useTemplateRef("summary");

function focusHeading() {
  summary.value?.focusHeading();
}

defineExpose({ focusHeading });
</script>

<style scoped lang="scss">
.slot-inspector-results {
  display: grid;
  gap: var(--sp-ref-scale-32);
}
</style>
